import { useEffect, useState } from "react";
import { KeyRound, ShieldCheck } from "lucide-react";
import api, { apiError } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function GatePage() {
  const { t } = useLang();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/gate/status")
      .then((r) => { if (!r.data.enabled) window.location.assign("/"); })
      .catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/gate/verify", { code: code.trim() });
      localStorage.setItem("apha_gate", data.gate_token);
      window.location.assign("/");
    } catch (err) {
      setError(err?.response?.status === 429 ? apiError(err) : t("gateInvalid"));
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1E3A8A] p-6" data-testid="gate-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 justify-center mb-8 text-white">
          <div className="h-10 w-10 rounded-md bg-white/10 border border-white/20 flex items-center justify-center font-heading font-bold text-lg">
            A
          </div>
          <div>
            <div className="font-heading font-semibold text-xl">APHA</div>
            <div className="text-xs text-blue-200">{t("appTagline")}</div>
          </div>
        </div>
        <div className="bg-white rounded-lg p-6 shadow-xl">
          <div className="flex items-center gap-2 mb-1">
            <KeyRound className="h-4 w-4 text-[#1E3A8A]" />
            <h1 className="font-heading text-lg font-semibold">{t("gateTitle")}</h1>
          </div>
          <p className="text-sm text-muted-foreground mb-5">{t("gateSubtitle")}</p>
          <form onSubmit={submit} className="space-y-3">
            <Input
              type="password"
              autoFocus
              autoComplete="off"
              data-testid="gate-code-input"
              placeholder={t("gateCodePlaceholder")}
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            {error && (
              <div data-testid="gate-error" className="text-sm text-[#991B1B] bg-[#FEE2E2] border border-[#FECACA] rounded-md px-3 py-2">
                {error}
              </div>
            )}
            <Button type="submit" data-testid="gate-submit-btn" disabled={busy || !code.trim()}
              className="w-full bg-[#1E3A8A] hover:bg-[#1c3479]">
              {busy ? "..." : t("gateContinue")}
            </Button>
          </form>
        </div>
        <div className="flex items-center gap-2 justify-center mt-6 text-blue-200 text-xs">
          <ShieldCheck className="h-3.5 w-3.5" />
          {t("gateFootnote")}
        </div>
      </div>
    </div>
  );
}
